<script setup>
/* eslint-disable */
import { useCompetitionsStore } from '@/stores/competitions';
import { computed, onMounted, ref, watch } from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { useRouter } from 'vue-router';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { useI18n } from 'vue-i18n';

import '@splidejs/vue-splide/css';
import { integer } from '@vuelidate/validators';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';

const competitionsStore = useCompetitionsStore();
const preSportsStore = usePreSportsStore();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();

const { t } = useI18n();
const router = useRouter();

const getTopCompetitions = async () => {
    await competitionsStore.fetchTopCompetitions();
}

const getSportPicks = async () => {
    await dateTimeSportFiltersStore.fetchQuickPicksCounters();
}

const props = defineProps({
	sport: {
		required: true
	},
})

onMounted(async () => {
    if (props.sport.id == undefined) return;

    competitionsStore.fetchTopCompetitionsSport(props.sport.id);
    dateTimeSportFiltersStore.fetchQuickPicksCounters(props.sport.id);
});


watch(() => props.sport, (newSport, oldSport) => {
	competitionsStore.fetchTopCompetitionsSport(newSport.id);
    dateTimeSportFiltersStore.fetchQuickPicksCounters(newSport.id);
}, {deep: true})

const direction = ref(document.dir);
const splideOptions = ref({
	direction: direction.value,
	pagination: false,
	arrows: false,
	autoWidth: true,
	trimSpace: 'move',
	gap: '1rem',
	breakpoints: {
		640: {
			gap: '0.5rem',
		},
	},
});

const combined_regions = computed(() => {
	let quick_options = [];
	if (usePlatformConfigurationStore().isNewPreSportsLayoutEnabled) {
		quick_options = [
			{
				id: 'today_games',
				name: t('general.todays_games'),
				fixtures_count: dateTimeSportFiltersStore.quick_picks_counters ? dateTimeSportFiltersStore.getQuickPicksTodayCounter : null,
				region_icon: null
			},
			{
				id: 'next_48',
				name: t('general.next_48_hours'),
				fixtures_count: dateTimeSportFiltersStore.quick_picks_counters ? dateTimeSportFiltersStore.getQuickPicks48HoursCounter : null,
				region_icon: null
			}
		];
	} else {
		quick_options = [

		];
	}


	return [...quick_options, ...competitionsStore.topCompetitionsSport];
});

const goToCompetition = (competition) => {
	if (!usePlatformConfigurationStore().isNewPreSportsLayoutEnabled) {
		if (competition.id == 'next_24') {
			router.push({ name: 'pre-sports-coupons-next-hours', params: { sport_id: props.sport.id, hours: '24'} } )
		} else if (competition.id == 'next_48') {
			router.push({ name: 'pre-sports-coupons-next-hours', params: { sport_id: props.sport.id, hours: '48'} } )
		} else {
			router.push({ name: 'pre-sports-competition', params: { sport_id: props.sport.id, region_id: competition.region_id, competition_id: competition.id} } )
		}
	} else {
		if (competition.id == 'today_games') {
			dateTimeSportFiltersStore.date_from = 'today';
			dateTimeSportFiltersStore.selected_option = 'today';

			router.push({ name: 'pre-sports-coupons-competitions-from-to', params: { sport_id: props.sport.id, from: dateTimeSportFiltersStore.date_from} } )
		} else if (competition.id == 'next_48') {
			dateTimeSportFiltersStore.date_from = '48_hours';
			dateTimeSportFiltersStore.selected_option = '48_hours';

			router.push({ name: 'pre-sports-coupons-competitions-from-to', params: { sport_id: props.sport.id, from: dateTimeSportFiltersStore.date_from} } )
		} else {
			dateTimeSportFiltersStore.resetStore();
			dateTimeSportFiltersStore.selected_option = 'all';
			dateTimeSportFiltersStore.date_from = 'all';
			router.push({ name: 'pre-sports-coupons-competitions-from-to', params: { sport_id: props.sport.id, competition_ids: competition.id,  from: dateTimeSportFiltersStore.date_from}});
		}

	}
}

</script>
<template>

<div class="quick-picks-container">
	<div class="quick-picks-slider">
		<Splide v-if="combined_regions.length > 0" :options="splideOptions">
			<SplideSlide v-for="competition in combined_regions" :key="competition.id" @click="goToCompetition(competition)">
				<div class="coupon-checkbox-outer">
					<div v-if="competition.region_icon" class="country-flag">
						<img :src="'/assets' + competition.region_icon" alt="flag-country">
					</div>
					<span>{{ competition.name }} {{ competition.fixtures_count != null ? '(' + competition.fixtures_count + ')' : '' }}</span>
				</div>
			</SplideSlide>
		</Splide>
	</div>
</div>

</template>
<style scoped>
	.quick-picks-container {
		margin-top: 8px;
		padding: 0px 0px 12px 0px;
		background-color: var(--dark);

	}

	.quick-picks-container p {
		color: var(--primary);
		font-size: 14px;
		font-weight: 700;
		padding: 3px 0px;
	}

	.coupon-checkbox-outer {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 8px 10px;
		background: transparent;
		border-radius: 5px;
		transition: 0.3s ease-in-out;
		color: var(--white);
		text-wrap: nowrap;
		border: 1px solid var(--tab-gray);
		cursor: pointer;
		gap: 5px;
	}

	.coupon-checkbox-outer:hover {
		background-color: var(--primary);
		border-color: var(--primary);
	}

	.coupon-checkbox-outer span {
		font-size: 16px;
		font-weight: 700;
	}

	.coupon-checkbox-outer .selected {
		background-color: var(--primary);
		border-color: var(--primary);
	}

	.country-flag {
		width: 18px;
		height: 18px;
		border-radius: 50%;
		overflow: hidden;
		display: flex;
		align-items: center;
	}

	.country-flag img {
		width: 18px;
		height: 28px;
		-o-object-fit: cover;
		object-fit: cover;
		-o-object-position: center;
		object-position: center;
	}

	:deep(.splide__arrow:disabled) {
		display: none !important;
	}

	@media screen and (min-width: 320px) and (max-width: 767px) {
		.coupon-checkbox-outer span {
		font-size: 12px;

		}
		:deep(.splide__arrows .splide__arrow--next) {
			right: 0px !important;
		}
	}

	@media screen and (min-width: 320px) and (max-width: 767px) {
		:deep(.splide__arrows .splide__arrow--prev) {
			left: 0px !important;
		}
	}

</style>